import { InputHTMLAttributes } from "react";
import styled from "styled-components";

interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  $error?: boolean;
  errorMessage?: string;
  password?: boolean;
  label?: string;
  helpText?: string;
  disabled?: boolean;
  $labelPosition?: "floating" | "top";
}

export const InputLabel = styled.p<TextFieldProps>`
  position: ${({ $labelPosition }) => ($labelPosition === "top" ? "static" : "absolute")};
  top: ${({ $labelPosition }) => ($labelPosition === "top" ? "auto" : "5px")};
  left: ${({ $labelPosition }) => ($labelPosition === "top" ? "auto" : "25px")};
  display: ${({ $labelPosition }) => ($labelPosition === "top" ? "block" : "auto")};
  margin-bottom: ${({ $labelPosition }) => ($labelPosition === "top" ? "6px" : "0")};
  color: ${({ theme, $error }) => ($error ? theme.colors.danger200 : theme.colors.grey900)};
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 170%;
`;

export const RequiredMark = styled.span`
  margin-left: 4px;
  color: #d92d20;
`;

export const Footnote = styled.span<TextFieldProps>`
  display: block;
  align-self: flex-start;
  margin-top: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${({ theme, $error }) => ($error ? theme.colors.danger200 : "#586166")};
  font-family: "Inter";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  text-align: left;
`;

export const TextField = styled.input<TextFieldProps>`
  width: 100%;
  height: ${({ $labelPosition }) => ($labelPosition === "top" ? "52px" : "100%")};
  border: 0.01em solid
    ${({ theme, $error }) => ($error ? theme.colors.danger200 : theme.colors.grey200)};
  border-radius: 10px;
  padding: ${({ $labelPosition }) => ($labelPosition === "top" ? "0 20px" : "25px 25px 20px 25px")};
  font-size: 16px;
  background: ${({ theme, disabled }) => (disabled ? theme.colors.grey200 : theme.colors.white)};
  border-radius: 40px;

  &:focus {
    outline: none !important;
    border: 0.1em solid
      ${({ theme, $error }) => ($error ? theme.colors.danger200 : theme.colors.secondary300)};
  }
  &:focus ~ ${InputLabel}, &:not(:placeholder-shown)&:not(:focus) ~ ${InputLabel} {
    font-size: 12px;
    transition: 0.4s;
    left: 25px;
  }
`;

export const Field = styled.div<TextFieldProps>`
  width: 100%;
  height: auto;
  position: relative;
  ${({ $labelPosition }) => $labelPosition === "top" && "display: flex; flex-direction: column;"}
`;

export const HelperText = styled.span<TextFieldProps>`
  font-size: 12px;
  margin-left: 16px;
  color: ${({ $error, theme }) => ($error ? theme.colors.danger200 : theme.colors.black)};
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
`;

export const Button = styled.span<TextFieldProps>`
  width: 50px;
  height: 50px;
  position: absolute;
  top: 7.5px;
  right: 5px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
